import {ATTACHED_DOCUMENT_TABLE_DISPLAY_MAX_LENGTH} from '../Constants/IP/attachedDocumentConstants';

export const parseAttachedDocumentDisplayName = (
  location: string,
  forTable = false
): string => {
  const segment = location.split('/').pop()?.split('?')[0] ?? '';
  const [displayName] = segment.split('|||');
  const name = (displayName || 'Document').trim();

  if (!forTable || name.length <= ATTACHED_DOCUMENT_TABLE_DISPLAY_MAX_LENGTH) {
    return name;
  }

  const max = ATTACHED_DOCUMENT_TABLE_DISPLAY_MAX_LENGTH;

  return `${name.slice(0, max - 3)}...`;
};
